import React from "react";
import { HelpCircle, BarChart3 } from "lucide-react";
import SportToggle from "../SportToggle";
import SettingsMenu from "../SettingsMenu";
import StatsModal from "../modals/StatsModal";
import { GAME_TITLE } from "../../lib/constants";

function Header({ onOpenHowToPlay }) {
    const [isStatsOpen, setIsStatsOpen] = React.useState(false);

    return (
        <>
            <header className="mb-2 sm:mb-4 px-4 sm:px-6">
                <div className="flex flex-col gap-4 sm:grid sm:grid-cols-[1fr_auto_1fr] sm:items-center">
                    {/* Left: Title */}
                    <div className="flex items-center justify-center sm:justify-start">
                        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-white tracking-tight">
                            {GAME_TITLE}
                        </h1>
                    </div>

                    {/* Center: Sport Toggle */}
                    <div className="flex justify-center">
                        <SportToggle />
                    </div>

                    {/* Right: Help icon + Stats + Settings */}
                    <div className="flex items-center justify-center sm:justify-end gap-2 sm:gap-3">
                        <button
                            onClick={onOpenHowToPlay}
                            className="p-2 sm:p-2.5 rounded-lg hover:bg-slate-800/60 transition-colors"
                            aria-label="How to play"
                        >
                            <HelpCircle size={20} className="sm:w-6 sm:h-6 text-slate-300" />
                        </button>
                        <button
                            onClick={() => setIsStatsOpen(true)}
                            className="p-2 sm:p-2.5 rounded-lg hover:bg-slate-800/60 transition-colors"
                            aria-label="View stats"
                        >
                            <BarChart3 size={20} className="sm:w-6 sm:h-6 text-slate-300" />
                        </button>
                        <SettingsMenu />
                    </div>
                </div>
            </header>
            <StatsModal open={isStatsOpen} onClose={() => setIsStatsOpen(false)} />
        </>
    );
}

export default Header;
